import React, { useEffect, useState } from 'react'
import styles from "../../../../../assets/stylesheets/sass/Management/UserGroup.module.scss";
import { Tooltip } from '@qastanfit/qastan-ui';
import { useSelector } from 'react-redux';
import { handleCreateGroup } from '../../../../../functions/updates';
import { getTranslation } from '../../../../../functions/translation';

function AddGroup({onCancel, onCreated}) {
    const allRelations = useSelector(state => state.allRelations);

    const [content_state, setcontent_state] = useState({});

    const [relation_search_string, setrelation_search_string] = useState("");
    const [search_relation_result, setsearch_relation_result] = useState(null);

    const [relations_in_group, setrelations_in_group] = useState([]);

    const [relation_name, setrelation_name] = useState("");

    const [is_creating, setis_creating] = useState(false);

    useEffect(()=>{
        fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
            res => res.json()
        ).then(
            json => {
                setcontent_state(json)
            }
        )
    }, [])

    const searchRelations = () => {
        let results = []
        let tmp_relations = [...allRelations];
        tmp_relations.forEach(relation => {
            if(relation.toLowerCase().includes(relation_search_string.toLowerCase())){
                results.push(relation)
            }
        });
        setsearch_relation_result(results)
    }

    const addToGroup = (relation) => {
        setrelations_in_group(prevState => {
            
            if(!prevState.includes(relation)){
                return [...prevState, relation];
            }
            else {
                return prevState
            }
        })
    }

    const removeFromGroup = (relation) => {
        setrelations_in_group(prevState => {
            if(prevState.includes(relation)){
                return prevState.filter(item => item !== relation);
            }
            else {
                return prevState
            }
        })
    }

    const createGroup = async () => {
        try {
            setis_creating(true);
            
            let f = await handleCreateGroup({
                token: JSON.parse(window.sessionStorage.getItem("user_data")).token,
                name: relation_name,
                relnr: relations_in_group.map(str => str.split('_')[0]).join(";")
            })

            if(f.errorcode === 0){
                onCreated()
            }
            else {
                console.error('Failed to create group')
                console.log(f);
            }
            

            setis_creating(false);
        } catch (error) {
            console.log(error)
            setis_creating(false)
        }
    }

  return (
    <>
    {Array.isArray(search_relation_result) && 
    <div className={styles.popup} style={{zIndex:1000}}>
        <div className={`${styles.searchresult} ${styles.container}`}>
            <div className={styles.header}>
                <p className={styles.title}>{search_relation_result.length} {getTranslation(content_state, "UserGroups", "add_title", "relationships found for")}: <span className={styles.searchstring}>"{relation_search_string}"</span></p> 
                <button onClick={()=>{setsearch_relation_result(null)}} className={styles.close}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="black" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M6 6L18 18" stroke="black" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></button>
            </div>

            <div className={styles.list}>
                {search_relation_result.map((relation, index) => {
                    return (
                        <div className={styles.row} key={index}>
                            <p>{relation.split('_')[0]} - {relation.split('_')[1]}</p>
                            <button disabled={relations_in_group.includes(relation)} onClick={()=>{addToGroup(relation)}} className={styles.add_btn}>
                                {relations_in_group.includes(relation) ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-check-circle-2"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path><path d="m9 12 2 2 4-4"></path></svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" x2="12" y1="8" y2="16"></line><line x1="8" x2="16" y1="12" y2="12"></line></svg>
                                }
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
    }

    <div className={styles.popup}>
        <div className={`${styles.addgroup} ${styles.container}`}>
            <div className={styles.header}>
                <p className={styles.title}>{getTranslation(content_state, "UserGroups", "add_main_title", "Create new group")}</p>
                <button className={styles.close} onClick={onCancel}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="black" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M6 6L18 18" stroke="black" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></button>
            </div>
            <p className={styles.description}>{getTranslation(content_state, "UserGroups", "add_main_description", "Choose the relationships that may be in this group. Groups will be able to find each other's files and documents.")}</p>

            <div>
                <p className={styles.label}>{getTranslation(content_state, "UserGroups", "add_main_groupsname", "Groupsname")}</p>
                <div className={styles.input_ct}>
                    <svg className={styles.icon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M7.49984 9.16667C9.34079 9.16667 10.8332 7.67428 10.8332 5.83333C10.8332 3.99238 9.34079 2.5 7.49984 2.5C5.65889 2.5 4.1665 3.99238 4.1665 5.83333C4.1665 7.67428 5.65889 9.16667 7.49984 9.16667Z" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.3335 17.5V15.8333C18.3329 15.0948 18.0871 14.3773 17.6346 13.7936C17.1821 13.2099 16.5486 12.793 15.8335 12.6083" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M13.3335 2.60834C14.0505 2.79192 14.686 3.20892 15.1399 3.7936C15.5937 4.37827 15.84 5.09736 15.84 5.8375C15.84 6.57765 15.5937 7.29674 15.1399 7.88141C14.686 8.46609 14.0505 8.88309 13.3335 9.06667" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    <input onChange={(e)=>{setrelation_name(e.currentTarget.value)}} className={styles.input} type="text" placeholder={`${getTranslation(content_state, "UserGroups", "add_main_groupsname", "Groupsname")}...`}/>
                </div>
            </div>

            <div>
                <p className={styles.label}>{getTranslation(content_state, "UserGroups", "add_main_addmembers", "Add group members")}</p>
                <div style={{display:"flex", gap:".5rem"}}>
                    <div className={styles.input_ct}>
                        <svg className={styles.icon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.4585 17.5L13.8335 13.875" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        <input onKeyDown={(e)=>{if(e.key === 'Enter'){searchRelations()}}} onChange={(e)=>{setrelation_search_string(e.currentTarget.value)}} className={styles.input} type="text" placeholder={`${getTranslation(content_state, "UserGroups", "add_main_searchrelation", "Search relationship")}...`}/>
                    </div>
                    <button onClick={()=>{searchRelations()}} className={styles.search_btn}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.5 17.5L13.875 13.875" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>
                </div>

                <div className={styles.table}>
                    <div className={styles.th}>
                        <div><p>{getTranslation(content_state, "UserGroups", "add_main_table_name", "Name")}</p></div>
                        <div><p>{getTranslation(content_state, "UserGroups", "add_main_table_relnr", "Relationship number")}</p></div>
                        <div></div>
                    </div>

                    {Array.isArray(relations_in_group) && relations_in_group.length > 0 && relations_in_group.map((relation, index)=>{
                        return (
                            <div className={styles.tr} key={index}>
                                <div><p>{relation.split('_')[1]}</p></div>
                                <div><p>{relation.split('_')[0]}</p></div>
                                <div>
                                    <Tooltip text={getTranslation(content_state, "UserGroups", "add_main_table_delete", "Delete")} position="left"><button onClick={()=>{removeFromGroup(relation)}}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 5H17.5" stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M15.8332 5V16.6667C15.8332 17.5 14.9998 18.3333 14.1665 18.3333H5.83317C4.99984 18.3333 4.1665 17.5 4.1665 16.6667V5" stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M6.6665 5V3.33333C6.6665 2.5 7.49984 1.66667 8.33317 1.66667H11.6665C12.4998 1.66667 13.3332 2.5 13.3332 3.33333V5" stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M8.3335 9.16667V14.1667" stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M11.6665 9.16667V14.1667" stroke="black" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></button></Tooltip>
                                </div>
                            </div>
                        )
                    })}
                    
                </div>
            </div>
            
            <div className={styles.footer}>
                <button onClick={()=>{createGroup()}} disabled={relation_name === "" || relations_in_group.length === 0 || is_creating} className={styles.add_btn}>{is_creating ? getTranslation(content_state, "UserGroups", "label_wait", "Please wait...") : getTranslation(content_state, "UserGroups", "add_main_table_button", "Create group")}</button>
            </div>
        </div>
    </div>
    </>
    )
}

export default AddGroup